export default __webpack_public_path__ + "static/media/zoryve-logo-generic-v2.c05fa189.png";